import { post, put, get, destroy, download, API_ENDPOINT } from '@/helpers/api'

export default {
    ROUTE_NAME (context, routeName) {
        context.commit('SET_CURRENT_ROUTE', routeName)
    },

    LOGIN (context, credentials) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'auth/user-login', credentials) 
                .then(response => {
                    context.commit('SET_USER', response.data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
  
    LOGOUT (context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'auth/logout')
            .then(response => {
                context.commit('SET_USER', null)
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
  
    PASSWORD_RESET_REQUEST (context, email) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'password/create', email)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PASSWORD_RESET (context, credentials) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'password/reset', credentials)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PASSWORD_RESET_TOKEN_FIND(context, token) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'password/find/' + token)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
  
    RESTRICTION_TYPES (context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/restriction-types')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },


    
    CREATE_RFID_USER (context, data) {
        return new Promise ((resolve, reject) => {
            post(API_ENDPOINT + 'tus-novo-mesto/rfid-users/create', data )
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    GET_RFID_USER (context, userId) {
        return new Promise((resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/rfid-users/' + userId)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    UPDATE_RFID_USER(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'tus-novo-mesto/rfid-users/' + data.user_uuid + '/update', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DELETE_RFID_USER (context, id) {
        return new Promise((resolve, reject) => {
            destroy(API_ENDPOINT + 'tus-novo-mesto/rfid-users/' + id + '/delete')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PARAMETERS_DATA (context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/parameters-data')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    GET_SETTINGS(context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/settings')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    SAVE_SETTINGS(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'tus-novo-mesto/settings/save', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PUBLISH (context, payload) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'tus-novo-mesto/mqtt-publish', payload)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    SYNC_USER(context, uuid) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/rfid-users/'+ uuid + '/sync')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    GET_PARKING_DATA(context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/parking-occupancy')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    UPDATE_PARKING_OCCUPANCY(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'tus-novo-mesto/parking-occupancy', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    TABLE (context, user_id) {
        return new Promise((resolve, reject) => {
          get(API_ENDPOINT + 'users/' + user_id + '/table')
          .then(response => {
            /*context.commit('setTable', response.data.data.table)
            context.commit('setStanja', response.data.data.stanja)
            context.commit('setNacini', response.data.data.nacini)*/
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
        })
      },
  
    TABLA (context, id_tabla) {
        return new Promise((resolve, reject) => {
            get(API_ENDPOINT + 'table/' + id_tabla)
            .then(response => {
            if(response.data.data) {
                context.commit('setTabla', response.data.data)
            }

            resolve(response)
            })
            .catch(error => {
            reject(error)
            })
        })
    },

    SEMAFOR (context, id_semafor) {
        return new Promise((resolve, reject) => {
            get(API_ENDPOINT + 'semaforji/' + id_semafor)
            .then(response => {
            context.commit('setSemafor', response.data.data)
            resolve(response)
            })
            .catch(error => {
            reject(error)
            })
        })
    },

    UPDATE_SEMAFOR (context, semafor) {
        return new Promise( (resolve, reject) => {
            put(API_ENDPOINT + 'semaforji/' + semafor.id_semafor + '/update', semafor)
            .then(response => {
            resolve(response)
            })
            .catch(error => {
            reject(error)
            })
        })
    },

    UPDATE_TABLA (context, tabla) {
        return new Promise( (resolve, reject) => {
            put(API_ENDPOINT + 'table/' + tabla.id_tabla + '/update', tabla)
            .then(response => {
            resolve(response)
            })
            .catch(error => {
            reject(error)
            })
        })
    },

    PARKING_GATES (context) {
        return new Promise((resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/parking-gates/devices')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PARKING_GATES_PARAMETERS_DATA (context) {
        return new Promise((resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/parking-gates/parameters-data')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

     DEVICE_STATUS(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'services/parking-gates/status', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DOWNLOAD_FILE(context, uuid) {
        return new Promise( (resolve, reject) => {
            download(API_ENDPOINT + 'tus-novo-mesto/exports/'+ uuid + '/download')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DELETE_FILE(context, uuid) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'tus-novo-mesto/exports/'+ uuid + '/delete')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    EXPORT(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'tus-novo-mesto/export/' + data.group, data.queryParameters)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    }


}